<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-blue">
          <div class="card-header">
            <div class="row">
              <div class="col-8">
                <h6 class="card-title">Tipo Documentos do Cliente</h6>
              </div>
              <div class="col-4 text-right">
                <button (click)="showModal()" class="btn btn-block btn-primary text-right" style="margin-top: 5px;"><i class="fa fa-plus"></i></button>
              </div>
            </div>
          </div>
          <div class="card-body table-responsive p-0" >
            <table  class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
              <thead >
              <tr>
                <th>Descrição</th>
                <th style="width: 20px">*</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let linha of listaDocumento | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                <td>{{linha.descricao}}</td>
                <td><button (click)="desativar(linha.id)"  class="btn btn-danger"><i class="fa fa-minus"></i></button></td>
              </tr>
              <tr *ngIf="listaDocumento.length == 0">
                <td colspan="10" class="text-center text-blue">Nenhum registro a ser mostrado</td>
              </tr>
              </tbody>
              <tfoot>
              <tr class="text-center">
                <td [attr.colspan]="3">
                  <pagination-controls class="pagination-sm"
                                       [autoHide]="false"
                                       [directionLinks]="true"
                                       previousLabel="Anterior"
                                       nextLabel="Próximo"
                                       (pageChange)="pageChange($event)">
                  </pagination-controls>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="adicionar" (click)="!loading && fecharModal()">
  <div class="box-novo-tipo-documento-cliente" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-id-card"></i> Novo tipo documento do cliente
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="descricao">Descrição</label>
            <input type="text" class="form-control" name="descricao" id="descricao"
                   [(ngModel)]="tipoDocumentoCliente.descricao" placeholder="Digite a descrição" [disabled]="loading">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="loading">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loading ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
